import { ReactNode } from 'react'
import { useRouter } from 'next/router'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { LocaleEnum } from 'shared/enums/locale-enum'

const NavLink = ({
  href,
  children,
  noLoco,
  signInLink,
}: {
  href: string
  children: string | JSX.Element
  noLoco?: boolean
  signInLink?: boolean
}): ReactNode => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum
  return (
    <LinkWithoutPrefetch
      locale={noLoco ? false : locale}
      className={`w-fit font-mulish whitespace-nowrap outline-hidden main-transition-colors ${
        signInLink
          ? `text-text-link hover:text-text-link focus-visible:text-text-link`
          : `text-text-secondary hover:text-text-link focus-visible:text-text-link`
      }`}
      href={href}
    >
      {children}
    </LinkWithoutPrefetch>
  )
}
export default NavLink
